import React, { Component } from 'react';
import {
    Row, Table
} from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import DataFormRow from '../DataFormGroup/DataFormRow';

class SearchStatistics extends Component {
    render() {
        return (
            <>
               <CollapseCard title="Statistics" open={localStorage.getItem('searchStatisticsIsOpen') === 'true' || false} cb={(isOpen) => localStorage.setItem('searchStatisticsIsOpen',isOpen)}>
                <Row key="formgroup_row" className="mx-3 mt-0 pt-0">
                  <Table id="searchFormGroupTable">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th colSpan={4} className="tableColumnDark">Amount</th>
                        <th colSpan={3}>Growth Amount</th>
                        <th colSpan={3} className="tableColumnDark">Growth %</th>
                      </tr>
                      <tr>
                        <th width="28%">&nbsp;</th>
                        <th width="6%" className="tableColumnDark">Current</th>
                        <th width="6%" className="tableColumnDark">Previous</th>
                        <th width="8%" className="tableColumnDark">Min</th>
                        <th width="8%" className="tableColumnDark">Max</th>
                        <th width="6%">Display</th>
                        <th width="8%">Min</th>
                        <th width="8%">Max</th>
                        <th width="6%" className="tableColumnDark">Display</th>
                        <th width="8%" className="tableColumnDark">Min</th>
                        <th width="8%" className="tableColumnDark">Max</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.search_option_groups.map((g, i) => (
                        <React.Fragment key={i + '_key'}>

                          {/* {(i % 2 === 0 && i !== 0) ? (<span key={g.i + '_divider'} className="w-100" />) : (<></>)} */}

                          <DataFormRow
                            clientToken={this.props.clientToken}
                            label={g.label}

                            key={g.keyBase}
                            keyBase={g.keyBase}

                            showComparison={this.props.previous_date !== null}

                            valBase={this.props.group_selections[g.keyBase + '_cur']}
                            valPrev={this.props.group_selections[g.keyBase + '_prev']}
                            valGrowth={this.props.group_selections[g.keyBase + '_growth']}
                            valGrowthPercent={this.props.group_selections[g.keyBase + '_growth_percent']}
                            valGrowthMin={this.props.group_selections[g.keyBase + '_growth_min']}
                            valGrowthMax={this.props.group_selections[g.keyBase + '_growth_max']}
                            valGrowthPercentMin={this.props.group_selections[g.keyBase + '_growth_percent_min']}
                            valGrowthPercentMax={this.props.group_selections[g.keyBase + '_growth_percent_max']}
                            valMin={this.props.group_selections[g.keyBase + '_value_min']}
                            valMax={this.props.group_selections[g.keyBase + '_value_max']}

                            type={g.type}
                            onTextChange={this.props.handleTextInputChange}
                            handleKeyUp={this.props.handleKeyUp}
                            onBooleanChange={this.props.handleBooleanInputChange}
                          />
                        </React.Fragment>
                      ))}
                    </tbody>
                  </Table>
                </Row>
              </CollapseCard>
            </>
        );
    }
}

export default SearchStatistics;